import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './UsuarioLogadoPage.css';
import TituloComponent from '../../components/Titulo/TituloComponent';

const UsuarioLogado = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const userData = location.state?.userData; // Dados passados pelo navigate
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil.nome;

  useEffect(() => {

    if (!userData.statusUsuario || statusUsuario !== 'logado') {
      console.log(' !!!! Usuário não logado ou dados ausentes. Redirecionando...');
      navigate('/area-restrita'); // Redireciona para a página de login
    } else {

        // vamos redirecionar o usuáiro de acordo com seu perfil
        if( nomePerfil === 'BAR GERENTE' ){
            console.log('vai redirecionar para página BarGerente');
            navigate('/bar-gerente'); // Redireciona para a página de gerente
        } else if( nomePerfil === 'BAR COZINHA' ){
            console.log('vai redirecionar para página BarCozinha');
        }

    //   console.log('----- PAGINA USUARIO LOGADO ------');
    //   // AQUI O USUÁRIO ESTÁ LOGADO
    //   console.log('Dados completos do usuário:', userData);
    //   console.log('Status do usuário:', statusUsuario);

      // Acessar e verificar o tipo de `dadosPerfil`
    //   const dadosPerfil = userData?.dadosPerfil;

    //   if (typeof dadosPerfil === 'string') {
    //     try {
    //       const perfilObjeto = JSON.parse(dadosPerfil);
    //       console.log('Dados do perfil (objeto após parse):', perfilObjeto);
    //     } catch (error) {
    //       console.error('Erro ao fazer JSON.parse em dadosPerfil:', error);
    //     }
    //   } else if (typeof dadosPerfil === 'object') {
    //     console.log('Dados do perfil (objeto):', dadosPerfil);
    //   } else {
    //     console.log('Formato inesperado de dadosPerfil:', dadosPerfil);
    //   }
    }
  }, [userData, statusUsuario, navigate]);

  // Função para deslogar o usuário
  const handleLogout = () => {
    // Limpa os dados da sessão
    // sessionStorage.removeItem('userData');
    // Remove todos os dados da sessão
    sessionStorage.clear();
    // Redireciona para a página de login (ou área restrita)
    navigate('/area-restrita');
  };

  // Se statusUsuario não for 'logado', o usuário não tem permissão
  if (statusUsuario !== 'logado') {
    return (
      <div className="erro-container">
        <h2>Erro: Você não está autorizado a acessar esta página.</h2>
      </div>
    );
  }

  return (
    <div className="usuario-logado-container">
        <TituloComponent />

        <h1 className="usuario-logado-title">Área do Usuário</h1>
        <div className="usuario-logado-box">
            <p className="usuario-logado-welcome">
            Bem-vindo, {userData?.user?.name || 'Usuário'}! 
            <br></br>
            Status: {userData.statusUsuario} 
            <br></br>
            Perfil: {nomePerfil}
            </p>
            <button className="usuario-logado-btn" onClick={handleLogout}>Logout</button>
        </div>
    </div>
  );
};

export default UsuarioLogado;
